module.exports = __webpack_public_path__ + "static/media/clouds.c03737fc.jpg";